import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Gavel,
  CalendarDays,
  Users,
  LogOut
} from "lucide-react";

const Item = ({ to, label, icon: Icon, onClick }) => (
  <NavLink
    to={to}
    onClick={onClick}
    className={({ isActive }) =>
      `
      flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition
      ${
        isActive
          ? "bg-blue-600/15 text-blue-400 ring-1 ring-blue-600/20"
          : "text-slate-300 hover:bg-slate-800/60 hover:text-slate-100"
      }
      `
    }
  >
    {Icon && <Icon size={18} className="opacity-80" />}
    <span>{label}</span>
  </NavLink>
);

const Section = ({ title, children }) => (
  <div className="mt-6">
    <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
      {title}
    </p>
    <div className="flex flex-col gap-1">{children}</div>
  </div>
);

export default function Sidebar({ open, onClose, role = "admin" }) {
  return (
    <>
      {/* OVERLAY MOBILE */}
      {open && (
        <div
          onClick={onClose}
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm lg:hidden"
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-50 w-64
          bg-[#0b0f19] border-r border-[#1f2937]
          transform transition-transform duration-300 ease-out
          ${open ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        <div className="flex h-full flex-col px-5 py-6">

          {/* LOGO */}
          <div className="mb-8">
            <p className="text-lg font-semibold text-slate-100">
              NGS Advogados
            </p>
            <p className="text-xs text-slate-400">
              {role === "cliente" ? "Área do Cliente" : "Painel Jurídico"}
            </p>
          </div>

          {/* MENU */}
          <nav className="flex-1 overflow-y-auto pr-1">

            {/* DASHBOARD */}
            <Section title="Visão geral">
              <Item
                to={role === "cliente"
                  ? "/app/cliente/dashboard"
                  : "/app/admin/dashboard"}
                label="Dashboard"
                icon={LayoutDashboard}
                onClick={onClose}
              />
            </Section>

            {/* GESTÃO */}
            <Section title="Gestão">

              {/* PROCESSOS */}
              <Item
                to={role === "cliente"
                  ? "/app/cliente/processos"
                  : "/app/admin/processos"}
                label="Processos"
                icon={Gavel}
                onClick={onClose}
              />

              {/* PRAZOS */}
              <Item
                to={role === "cliente"
                  ? "/app/cliente/prazos"
                  : "/app/admin/prazos"}
                label="Prazos"
                icon={CalendarDays}
                onClick={onClose}
              />

              {/* CLIENTES – SOMENTE ADMIN */}
              {role === "admin" && (
                <>
                  <Item
                    to="/app/admin/clientes"
                    label="Clientes"
                    icon={Users}
                    onClick={onClose}
                  />

                  <Item
                    to="/app/admin/clientes/novo"
                    label="Novo Cliente"
                    icon={Users}
                    onClick={onClose}
                  />
                </>
              )}

            </Section>
          </nav>

          {/* SAIR */}
          <div className="pt-4 border-t border-[#1f2937]">
            <button
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("role");
                window.location.href = "/app/login";
              }}
              className="
                flex w-full items-center gap-3 rounded-xl px-4 py-3
                text-sm font-medium text-slate-300
                hover:bg-red-500/10 hover:text-red-400 transition
              "
            >
              <LogOut size={18} />
              <span>Sair</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
